export default __webpack_public_path__ + "static/media/tvcorporativa.b5f0d8df.png";